import { Link } from "react-router-dom";
import { ArrowLeft } from "lucide-react";

const S = ({ title, children }) => (
  <section className="mb-10">
    <h2 className="font-serif text-2xl text-[#0A0A0A] mb-4">{title}</h2>
    <div className="text-base text-[#333] leading-relaxed space-y-3">{children}</div>
  </section>
);

export default function PrivacyPolicy() {
  return (
    <div data-testid="privacy-page" className="min-h-screen bg-[#FAF9F6]">
      <header className="border-b border-[#E5E5E5]">
        <div className="max-w-3xl mx-auto px-6 h-16 flex items-center justify-between">
          <Link to="/"><img src="/logo.png" alt="Funghetto Roma" className="h-8 w-auto" /></Link>
          <Link to="/" data-testid="privacy-back-link" className="inline-flex items-center gap-2 text-xs uppercase tracking-[0.2em] text-[#555] hover:text-[#6B1E33] transition-colors">
            <ArrowLeft size={14} /> Torna al sito
          </Link>
        </div>
      </header>

      <main className="max-w-3xl mx-auto px-6 py-16">
        <p className="text-xs uppercase tracking-[0.3em] text-[#6B1E33] mb-4">Informativa ai sensi del Reg. UE 2016/679 (GDPR)</p>
        <h1 className="font-serif text-4xl sm:text-5xl text-[#0A0A0A] mb-12">Privacy Policy</h1>

        <S title="1. Titolare del trattamento">
          <p>
            Il titolare del trattamento dei dati personali è <strong>Hosneara Begum</strong>,
            P.IVA <strong>18366311001</strong>, con sede legale in <strong>Via Urbano II 32, 00167 Roma (RM)</strong>,
            titolare del sito www.funghettoroma.it.
          </p>
          <p>
            Contatti: <a href="mailto:info@funghettoroma.it" className="text-[#6B1E33] underline">info@funghettoroma.it</a> — Tel. +39 352 098 1771.
          </p>
        </S>

        <S title="2. Dati che raccogliamo">
          <p>Attraverso il modulo di prenotazione del sito raccogliamo:</p>
          <ul className="list-disc pl-6 space-y-1">
            <li>Nome e cognome</li>
            <li>Indirizzo email</li>
            <li>Numero di telefono</li>
            <li>Data, orario e numero di ospiti della prenotazione</li>
            <li>Eventuali note inserite volontariamente (es. allergie, richieste particolari)</li>
          </ul>
          <p>Non raccogliamo dati di pagamento e non effettuiamo profilazione.</p>
        </S>

        <S title="3. Perché trattiamo i dati">
          <p>
            I dati vengono utilizzati esclusivamente per gestire la tua prenotazione e ricontattarti
            in merito ad essa (conferma, modifica o cancellazione via email, telefono o WhatsApp).
          </p>
          <p>
            Base giuridica: esecuzione di misure precontrattuali e contrattuali richieste
            dall'interessato (art. 6, par. 1, lett. b GDPR).
          </p>
        </S>

        <S title="4. Per quanto tempo conserviamo i dati">
          <p>
            I dati delle prenotazioni sono conservati per il tempo necessario alla gestione del
            servizio e comunque non oltre 12 mesi dalla data della prenotazione, salvo obblighi di legge.
          </p>
        </S>

        <S title="5. Chi può accedere ai dati">
          <p>
            I dati sono trattati dal titolare e dai fornitori tecnici che gestiscono il sito
            (servizio di hosting, servizio di invio email e messaggistica), nominati responsabili
            del trattamento ai sensi dell'art. 28 GDPR. I dati non sono venduti né ceduti a terzi
            per finalità di marketing.
          </p>
        </S>

        <S title="6. I tuoi diritti">
          <p>
            Puoi in qualsiasi momento chiedere l'accesso, la rettifica, la cancellazione o la
            limitazione del trattamento dei tuoi dati scrivendo a{" "}
            <a href="mailto:info@funghettoroma.it" className="text-[#6B1E33] underline">info@funghettoroma.it</a>.
          </p>
          <p>
            Hai inoltre diritto di proporre reclamo al Garante per la protezione dei dati personali
            (www.garanteprivacy.it).
          </p>
        </S>

        <p className="text-sm text-[#777] mt-16">Ultimo aggiornamento: ottobre 2026</p>
      </main>
    </div>
  );
}
